"use client"

import React from "react"
import { esimInfoData } from "./Data/EsimInfoData"
import { useMobileContext } from "./MobileContext"
import { Card, Typography, Table } from "antd"
import { useTranslation } from "react-i18next"

const { Title, Paragraph } = Typography

interface TableData {
  headers: string[]
  rows: string[][]
}

interface SectionContent {
  subheading?: string
  details: string
}

interface Section {
  heading: string
  content?: SectionContent[]
  table?: TableData
}

interface EsimInfoProps {
  data?: typeof esimInfoData
}

const EsimInfo: React.FC<EsimInfoProps> = ({ data = esimInfoData }) => {
  const isMobile = useMobileContext()
  const { t } = useTranslation()
  
  return (
    <Card 
      className="esim-tab-content"
      variant="borderless"
    >
      <Title level={2}>{t(data.title)}</Title>
      <div className="space-y-6">
        {data.sections.map((section, idx) => (
          <div key={idx} className="space-y-4">
            <Title level={3}>{t(section.heading)}</Title>
            {section.content &&
              section.content.map((item, subIdx) => (
                <div key={subIdx} className="space-y-2">
                  {item.subheading && (
                    <Title level={4}>{t(item.subheading)}</Title>
                  )}
                  <Paragraph className="text-gray-700 whitespace-pre-line">{t(item.details)}</Paragraph>
                </div>
              ))}
            {section.table && (
              <div className="te-table-wrapper">
                <Table 
                  dataSource={section.table.rows.map((row, index) => ({
                    key: index,
                    ...row.reduce((acc, cell, cellIndex) => {
                      acc[`col${cellIndex}`] = t(cell);
                      return acc;
                    }, {} as Record<string, string>)
                  }))}
                  columns={section.table.headers.map((header, index) => ({
                    title: t(header),
                    dataIndex: `col${index}`,
                    key: `col${index}`,
                    ellipsis: isMobile,
                  }))}
                  pagination={false}
                  bordered
                  scroll={{ x: isMobile ? 480 : undefined }}
                  size={isMobile ? 'small' : 'middle'}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </Card>
  )
}

export default EsimInfo